<template>
  <div  v-loading="loading">
    <div class="user_body" v-if="info&&info.order_no">
      <span class="title">订单详情</span>
      <span
        class="order_id"
      >订单号:{{info.order_no}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;协议号：{{info.xieyi_no}}</span>
      <div class="line"></div>
      <span class="title">项目进度</span>
      <div class="div_lls">
        <div class="dev_list" v-for="(item,index) in stepList" :key="index">
          <div class="dev_item1">
            <span></span>
            <span v-if="stepList.length!=(index+1)"></span>
          </div>
          <div class="dev_item2">
            <div class="dev_item2_view1">
              <span class="time1">{{item.createtime}}</span>
              <div class="sub_item">
                <div class="sub_time">
                  <i class="el-icon-success" c></i>
                  <span class="time1">{{item.title}}</span>
                </div>
                <div class="sdesc">{{item.content}}</div>
              </div>

              <span class="time2">详情></span>
            </div>
           
          </div>
        </div>
      </div>
 
      <div class="line"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MyOrderInfoView",
  data() {
    return {
      loading: false,
      info: {},
      stepList: []
    };
  },
  beforeMount(){
    this.getServeOrderDetail()
  },
  mounted() {},
  methods: {
    getServeOrderDetail(){
      this.loading = true
      this.$api.getServeOrderDetail({order_id:this.$route.params.id}).then(res=>{
        console.log(res)
        this.loading = false
        if(res.code == 1){
          this.info = res.data.order
          this.stepList = res.data.step_list
          console.log(this.info)
        }else{
          this.$message.error(res.message)
        }
      }).catch(err=>{
        console.log(err)
        this.loading = false
      })
    }
  }
};
</script> 

<style lang="less"  scoped>
.user_body {
  background: #ffffff;
  padding: 25px;
  display: flex;
  flex-direction: column;
}
.title {
  color: #666666;
  font-size: 16px;
}
.order_id {
  color: #000000;
  font-size: 14px;
  line-height: 20px;
  margin-top: 40px;
}
.line {
  height: 1px;
  background: #f1f1f1;
  margin-top: 15px;
  margin-bottom: 15px;
}
.status {
  color: #999999;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 16px;
  line-height: 28px;
}

.time {
  margin-left: 20px;
  margin-right: 20px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 10px;
}
.time_content1 {
  color: #666666;
  font-size: 12px;
  text-align: center;
  flex: 1;
}
.time_content2 {
  color: #666666;
  font-size: 12px;
  text-align: center;
  flex: 1;
  visibility: hidden;
}
.product_info {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: #000000;
  font-size: 14px;
}
.product_info img {
  width: 80px;
  height: 80px;
}
.address {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.address_1 {
  color: #000000;
  font-size: 16px;
  margin-top: 10px;
  margin-bottom: 20px;
}
.add_text2 {
  color: #666666;
  font-size: 14px;
  margin-bottom: 10px;
}

.div_lls { 
  padding: 20px 0px;
  margin-top: 10px;
}
.dev_list {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  /* 确保子元素拉伸以填充容器 */
}

.dev_item1 {
  width: 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  position: relative;
  height: 50px;
  /* 为伪元素定位做准备 */
}

.dev_item1 span:nth-child(odd) {
  width: 12px;
  height: 12px;
  background-color: #F39800; 
  border: 3px solid #ffffff;
  border-radius: 50%;
  z-index: 9999;
  /* 圆形 */
}

.dev_item1 span:nth-child(even) {
  content: "";
  position: absolute;
  left: 50%;
  top: 10px;
  /* 调整这个值以避开顶部圆点 */
  bottom: -2px;
  width: 5px;
  background-color: #F39800;
  transform: translateX(-50%);
}

.dev_item2 {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 20px;
  flex: 1;
  width: 90%;
}

.dev_item2_view1 {
  color: #777777;
  font-size: 14px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 97%;
}
.time1 {
  color: #333333;
  font-size: 14px;
}

.el-icon-success {
  color: #20B759;
}
.sub_item {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  flex: 1;
  margin-left: 20px;
  .sdesc{
    color: #888888;
    font-size: 12px;
  }
}
.sub_time {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  // margin-left: 10px;
}
.time2{
    color:#3C9C8F;
    font-size: 14px;
}
</style>
  



